import { Routes } from '@angular/router';

export const routes: Routes = [
     {
        path: '',
         data: {
          headerBg: 'solid',    
          title: 'About Us'
        },
        
        loadComponent: () => import('./features/home/pages/home/home.component').then(m => m.HomeComponent)
      },
      {
        path: 'home',
         data: {
          headerBg: 'solid',    
          title: 'About Us'
        },
        
        loadComponent: () => import('./features/home/pages/home/home.component').then(m => m.HomeComponent)
      },
      {
        path: 'about',
          data: {
          headerBg: '#F6F9FE',    
          title: 'About Us'
        },
        loadComponent: () => import('./features/about-us/about-us.component').then(m => m.AboutUsComponent)
      },
       {
        path: 'contact',
          data: {
          headerBg: '#F6F9FE',    
          title: 'Contact Us'
        },
        loadComponent: () => import('./features/contact-us/contact-us.component').then(m => m.ContactUsComponent)
      },
      {
        path: 'appointment',
          data: {
          headerBg: '#F6F9FE',    
          title: 'appointment'
        },
        loadChildren: () => import('./features/appointment/appointment.routes').then(m => m.appointmentRoutes)
      },
];
